module.exports = __webpack_public_path__ + "bw.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/bw.svg
// module id = 472
// module chunks = 0